import { createTheme as r } from "flowbite-react";
const d = r({
  base: "block w-full rounded-lg border p-2.5 text-sm focus:outline-hidden focus:ring-1 disabled:cursor-not-allowed disabled:opacity-50",
  colors: {
    gray: "bg-white/10 dark:bg-white/10 backdrop-blur-[15px] border-transparent dark:border-transparent text-white dark:text-white placeholder-white/50 dark:placeholder-white/50 focus:border-transparent dark:focus:border-transparent dark:focus:ring-0",
    failure: "bg-white/10 dark:bg-white/10 backdrop-blur-[15px] border-red-500 dark:border-red-400 text-red-900 placeholder-red-700/50 dark:placeholder-red-700/50 focus:border-red-500 dark:focus:border-red-500 focus:ring-red-500 dark:focus:ring-red-500"
  },
  withShadow: {
    on: "",
    off: ""
  }
});
export {
  d as theme
};
